import {
    FETCH_CATEGORY_MAPPING,
    FETCH_CATEGORY_MAPPING_SUCCESS,
    FETCH_CATEGORY_MAPPING_FAILURE,
    FETCH_CATEGORY_MAPPING_LIST,
    FETCH_CATEGORY_MAPPING_LIST_SUCCESS,
    FETCH_CATEGORY_MAPPING_LIST_FAILURE,
    SAVE_CATEGROY_MAPPING_REQUEST,
    SAVE_CATEGORY_MAPPING_SUCCESS,
    SAVE_CATEGORY_MAPPING_FAILURE
} from "./actionType";

const initialState = {
    categoryMapping: [],
    mapList: [],
    loading: false,
    error: null,
    success: false
};

export default function categoryMappingReducer(state = initialState, action) {

    switch (action.type) {
        case FETCH_CATEGORY_MAPPING:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_CATEGORY_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                categoryMapping: action.payload || [],
            };
        case FETCH_CATEGORY_MAPPING_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case FETCH_CATEGORY_MAPPING_LIST:
            return { ...state, loading: true };
        case FETCH_CATEGORY_MAPPING_LIST_SUCCESS:
            return { ...state, loading: false, mapList: action.payload.data };
        case FETCH_CATEGORY_MAPPING_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SAVE_CATEGROY_MAPPING_REQUEST:
            return { ...state, loading: true, success: false, error: null };

        case SAVE_CATEGORY_MAPPING_SUCCESS:
            return { ...state, loading: false, success: true, mappingData: action.payload, error: null };

        case SAVE_CATEGORY_MAPPING_FAILURE:
            return { ...state, loading: false, success: false, error: action.payload };
        default:
            return state;
    }
}